/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maroon_Round_Buzzard_KickInputs */

const fr_maroon_round_buzzard_kick = /** @type {(inputs: Maroon_Round_Buzzard_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un nouveau mot de passe`)
};

/**

* @param {Maroon_Round_Buzzard_KickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const maroon_round_buzzard_kick = /** @type {((inputs?: Maroon_Round_Buzzard_KickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maroon_Round_Buzzard_KickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_maroon_round_buzzard_kick(inputs)
});